@if (nonRunners.length) {
    <li class="non-runners">
        <span class="caption-text">{{ messages.NonRunners }}</span>
        <span class="value-text">
            @for (participant of nonRunners; track $index; let last = $last) {
                <span>
                    <b>{{ participant.raceCardNumber }}</b>
                    @if (last) {
                        {{ participant.name }}
                    } @else {
                        {{ participant.name }},
                    }
                </span>
            }
        </span>
    </li>
}
